import { useLocation } from 'react-router-dom'
import React, { createContext, useContext, useState, useEffect } from 'react'

const SelectedColorContext = createContext()
const STORAGE_KEY = 'product_colors'

export function SelectedColorProvider({ children }) {
  const [productColors, setProductColors] = useState(() => {
    const savedColors = localStorage.getItem(STORAGE_KEY)
    return savedColors ? JSON.parse(savedColors) : {}
  })

  const { search } = useLocation()

  useEffect(() => {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(productColors))
  }, [productColors])

  useEffect(() => {
    const params = new URLSearchParams(search)
    const color = params.get('color')
    const productSku = params.get('product')

    if (color && productSku) {
      setProductColors(prev => ({
        ...prev,
        [productSku]: color,
      }))
    }
  }, [search])

  const selectedColor = (() => {
    const params = new URLSearchParams(search)
    const productSku = params.get('product')
    return productSku && productColors[productSku]
      ? productColors[productSku]
      : null
  })()

  const setSelectedColor = (color, productSku) => {
    if (!productSku) return

    setProductColors(prev => {
      const newColors = { ...prev }

      if (color === null) {
        delete newColors[productSku]
      } else {
        newColors[productSku] = color
      }

      return newColors
    })
  }

  const getProductColor = productSku => {
    return productSku && productColors[productSku]
      ? productColors[productSku]
      : null
  }

  return (
    <SelectedColorContext.Provider
      value={{
        selectedColor,
        setSelectedColor,
        productColors,
        setProductColors,
        getProductColor,
      }}
    >
      {children}
    </SelectedColorContext.Provider>
  )
}

export const useSelectedColor = () => useContext(SelectedColorContext)
